import React from 'react'

import { Button } from '../../../main/components/button'
import { DialogBody, DialogFooter } from '../../../main/components/dialog'
import { Paragraph } from '../../../main/components/typography'

type SuccessContentProps = {
  onClose?: () => void
}

export default function SuccessContent({ onClose }: SuccessContentProps) {
  return (
    <>
      <DialogBody>
        <div className="p-4 text-center">
          <Paragraph>Alert successfully created.</Paragraph>
          <Paragraph>Do you wish to proceed to alerts?</Paragraph>
        </div>
      </DialogBody>
      <DialogFooter>
        {onClose && <Button onClick={onClose}>Close</Button>}
        <Button as="a" href="/alerts.ashx" theme="blue">
          Proceed
        </Button>
      </DialogFooter>
    </>
  )
}
